<script lang="ts">
    import { _ } from 'svelte-i18n';
    import InfoColor from '../../shared/InfoColor.svelte';
    import Opacity from '../../shared/Opacity.svelte';
    import IconFlashOn from '../../shared/Icons/IconFlashOn.svelte';
    import { JobApi } from './JobApi.js';
    import { get } from 'svelte/store';
    import { api } from '../../../stores/api.js';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem.js';
    import { debug } from '../../../stores/store';

    export let adHoc: boolean;
    export let jobId: number;
    export let disabled: boolean = false;

    let scale: number = 0.5;

    let adHocClickable: boolean = true;
    let changingAdHoc: boolean = false;

    function toggleAdhocStatus() {
        // if (!friendlyTargetDate.isToday()) {
        //     console.warn('Cannot toggle ad-hoc status for not today jobs');
        //     return;
        // }
        if (!adHocClickable) {
            console.warn('Ad-hoc status cannot be changed (disabled by variable adHocClickable)');
            return;
        }
        if (jobId === null) {
            console.error('JobId is null (cannot toggle ad-hoc status)');
            return;
        }
        if (disabled) {
            console.warn('Ad-hoc status cannot be changed (disabled by variable disabled)');
            changingAdHoc = true;
            setTimeout(() => {
                changingAdHoc = false;
            }, 100);
            return;
        }
        changingAdHoc = true;
        JobApi.setAdhocStatus(get(api), jobId, !adHoc)
            .then(res => {
                adHoc = !adHoc;
                $NotificationSystem.reload();
            })
            .catch(err => {
                console.error('Error toggling ad-hoc status', err);
            })
            .finally(() => {
                changingAdHoc = false;
            });
    }
</script>

{#if adHoc}
    <div on:click|stopPropagation={toggleAdhocStatus}>
        <!--        <InfoColor>-->
        <IconFlashOn {scale} title={$_('Ad-hoc (wł.)')} spin={changingAdHoc} />
        <!--        </InfoColor>-->
    </div>
{:else if $debug}
    <div on:click|stopPropagation={toggleAdhocStatus}>
        <Opacity opacity={0.2}>
            <IconFlashOn {scale} title={$_('Ad-hoc (wył.)')} spin={changingAdHoc} />
        </Opacity>
    </div>
{/if}
